import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  menuPaper: {
    height: "195px",
  },
});

export default useStyles;
